var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99745 5.04427L9.09416 7.86093C9.19949 7.95673 9.32413 8.00304 9.46808 7.99985C9.61203 7.99665 9.73667 7.94715 9.842 7.85135C9.94733 7.75554 10 7.64217 10 7.51124C10 7.38031 9.94733 7.26694 9.842 7.17114L6.59783 4.22993C6.51357 4.15329 6.41877 4.09581 6.31344 4.05748C6.20811 4.01916 6.10278 4 5.99745 4C5.89212 4 5.78679 4.01916 5.68146 4.05748C5.57613 4.09581 5.48133 4.15329 5.39707 4.22993L2.1529 7.18072C2.04757 7.27652 1.99666 7.38829 2.00017 7.51603C2.00368 7.64377 2.0581 7.75554 2.16343 7.85135C2.26876 7.94715 2.3934 7.99506 2.53735 7.99506C2.68131 7.99506 2.80595 7.94715 2.91128 7.85135L5.99745 5.04427Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpS);
export default __webpack_public_path__ + "static/media/arrow-up-s.578b22b16b279d439cb3e75d8309accc.svg";
export { ForwardRef as ReactComponent };